import React from 'react';
import styles from './progress.css';
import PropTypes from 'prop-types';
import Box from '../box/box.jsx';
import Modal from '../titled-modal/titled-modal.jsx';

const Progress = ({text, num, title, onRequestClose}) => (
    <Modal
        className={styles.modalContent}
        contentLabel={title}
        onRequestClose={onRequestClose}
    >
        <Box className={styles.body}>
            <div className={styles.wrapper}>
                <div className={styles.title}>
                    {`${num}%`}
                </div>
                <div className={styles.pie}>
                    <div
                        className={styles.pies}
                        style={{
                            transform: `rotate(${num > 50 ? (num - 50) * 3.6 : num * 3.6}deg)`,
                            background: num > 50 ? '#F08438' : '#FFF'
                        }}
                    />
                </div>
                <div className={styles.des}>
                    {text}
                </div>
            </div>
        </Box>
    </Modal>
);
Progress.propTypes = {
    num: PropTypes.number,
    onRequestClose: PropTypes.func.isRequired,
    text: PropTypes.string,
    title: PropTypes.string
};
export default Progress;
